<template>
  <div>
    <CollapsibleCard
      :value="true"
      collapsibleIcon="mdi-calendar-month"
      collapsibleTitle="Bookinger"
      :padding="true"
      class="mb-6"
    >
      <template v-slot>
        <div v-if="loading" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div v-else-if="activeBooking || bookings.length > 0">
          <v-card
            class="mb-4"
            v-if="activeBooking"
            color="input"
            prepend-icon="mdi-home"
            append-icon="mdi-home"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="text-h5 mb-1">
                  Aktiv booking
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-icon>
                <v-icon color="error" @click="deleteBooking(bookingActive)">
                  mdi-delete
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
            <!-- <v-card-title>Aktiv booking</v-card-title> -->

            <CardContent class="pb-1" v-model="activeBooking" />
          </v-card>

          <v-subheader v-if="bookings.length > 0" style="height: 30px">
            Dine fremtidige bookinger
          </v-subheader>

          <v-list
            v-for="(booking, index) in bookings"
            :key="index"
            class="py-0"
            color="cardSurface"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ booking.barrackName }} -
                  {{ booking.roomName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ booking.fromDate | moment("ddd DD.MM.YYYY") }} ~
                  {{ booking.toDate | moment("ddd DD.MM.YYYY") }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  {{ booking.projectName }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="listSubShowText">
                  {{ booking.location }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon color="error" @click="deleteBooking(booking)">
                  mdi-delete
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-divider v-if="index + 1 !== bookings.length" inset></v-divider>
          </v-list>
        </div>
        <div v-else>
          <v-alert type="info">Du har ingen bookinger lagt inn</v-alert>
        </div>
      </template>
    </CollapsibleCard>

    <ConfirmDialog
      v-model="showConfirmDelete"
      title="Bekreft"
      icon="mdi-calendar-remove"
      :text="confirmText"
      btnActionName="Bekreft"
      @action="delBooking"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import barracksApi from "@/api/barracksApi";

import { BarrackBookingDto } from "@/types/bookingInterface";

import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";
import notification from "@/helpers/notification";

export default Vue.extend({
  name: "Competence",
  data: () => ({
    showCompetencDialog: false,
    bookings: [] as Array<BarrackBookingDto>,
    loading: true,
    showConfirmDelete: false,
    bookingId: null as null | number,
    confirmText: "",
  }),
  async mounted() {
    //get bookings
    this.loading = true;
    await barracksApi.getBookingsBarracks().then((res) => {
      this.bookings = res;
      this.loading = false;
    });
  },
  methods: {
    ...mapActions({
      setBookingActive: "profile/setBookingActive",
    }),
    deleteBooking(booking) {
      this.confirmText = `Sikker på at du vil slette booking av ${
        booking.roomName
      } på ${booking.projectName} fra ${moment(booking.fromDate).format(
        "ddd DD.MM.YY"
      )} til ${moment(booking.toDate).format("ddd DD.MM.YY")}?`;

      this.showConfirmDelete = true;
      this.bookingId = booking.id;
    },
    async delBooking() {
      await barracksApi.delBookingBarracks(this.bookingId).then(async () => {
        notification.success(
          "Booking er kansellert. Du vil få bekreftelse på mail"
        );
        this.setBookingActive();
        await barracksApi.getBookingsBarracks().then((res) => {
          this.bookings = res;
        });
        this.showConfirmDelete = false;
      });
    },
  },
  computed: {
    ...mapGetters({
      bookingActive: "profile/bookingActive",
      isBookingActive: "profile/isBookingActive",
    }),
    activeBooking(): Array<any> | null {
      if (this.isBookingActive) {
        var items = [
          {
            icon: "mdi-home-city-outline",
            title: "Prosjekt",
            content: this.bookingActive.projectName,
          },
          {
            icon: "mdi-home-outline",
            title: "Brakkerigg",
            content: this.bookingActive.barrackName,
          },
          {
            icon: "mdi-bed-outline",
            title: "Rom",
            content: this.bookingActive.roomName,
          },
          {
            icon: "mdi-calendar-arrow-left",
            title: "Fra",
            content: moment(this.bookingActive.fromDate).format("ddd DD.MM.YY"),
          },
          {
            icon: "mdi-calendar-arrow-right",
            title: "Til",
            content: moment(this.bookingActive.toDate).format("ddd DD.MM.YY"),
          },
          {
            icon: "mdi-map-marker-outline",
            title: "Lokasjon",
            content: this.bookingActive.location,
            showAllText: true,
          },
          {
            icon: "mdi-account-outline",
            title: "Ansvarlig",
            content: this.bookingActive.responsibleName,
            showAllText: true,
          },
          {
            icon: "mdi-door-closed-lock",
            title: "Dørkode",
            content: this.bookingActive?.barracks?.doorCode,
            showAllText: true,
          },
          {
            icon: "mdi-wifi-lock",
            title: "Wifi kode",
            content: this.bookingActive?.barracks?.wifiPassword,
            showAllText: true,
          },
        ];

        return items;
      }
      return null;
    },
  },
  components: {
    CollapsibleCard,
    CardContent,
    ConfirmDialog,
  },
});
</script>

<style lang="scss" scoped>
.listSubShowText {
  white-space: normal;
}
</style>
